import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcCheckboxGroupComponent} from './ac-checkbox-group.component';
import {AcTextFieldModule} from '../ac-text-field/ac-text-field.module';
import {AcCheckboxModule} from '../ac-checkbox/ac-checkbox.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AcTextFieldModule,
        AcCheckboxModule
    ],
    declarations: [
        AcCheckboxGroupComponent,
    ],
    exports: [
        AcCheckboxGroupComponent,
    ]
})
export class AcCheckboxGroupModule {
}
